import React from 'react';
import times from 'lodash/times';
import { Box } from '@mui/material';

import { useTheme } from '@mui/system';
import { SkeletonDealCard } from '@components/DealCard';

const LoadingSkeletons = ({ amount = 5 }: { amount?: number }) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  return (
    <Box
      sx={{
        backgroundColor: isDarkMode ? 'transparent' : 'white',
        margin: '10px auto'
      }}
    >
      {times(amount, (i) => {
        return <SkeletonDealCard key={i} />;
      })}
    </Box>
  );
};

export default LoadingSkeletons;
